module.exports = __webpack_public_path__ + "img/kolor-1-19.a04ec361.jpg";